export default "__VITE_ASSET__mqAqTs9l__"